var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"f2gChip",attrs:{"disabled":"","label":"","color":_vm.color,"text-color":_vm.textColor}},[_c('F2gIcon',{attrs:{"height":35,"stroke":_vm.iconColor,"strokeWidth":4,"value":_vm.icon,"width":27}}),_c('span',[_vm._v(_vm._s(_vm.text.toUpperCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }